// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__39tmN","footer":"ModalInfo_footer__1aj5I"};